import React from 'react';
import { TOS_SECTIONS } from '../modals/TosModal';

// ─── Terms of Service Page ───────────────────────────────────────────────────
function TosPage({ setTab }) {
  return (
    <div className="section" style={{ maxWidth:860 }}>
      <div className="section-title" style={{color:'#e8c97a'}}>Terms of Service</div>
      <p className="section-sub" style={{color:'#b8a888'}}>South Jersey Vendor Market Platform Agreement — effective upon registration</p>

      {TOS_SECTIONS.map(({ title, body }) => (
        <div key={title} style={{ marginBottom:28 }}>
          <div style={{ fontFamily:'Playfair Display,serif', fontSize:18, color:'#e8c97a', marginBottom:8 }}>{title}</div>
          {body.split('\n\n').map((para, i) => (
            <p key={i} style={{ fontSize:14, color:'#d4c8a8', lineHeight:1.8, marginBottom:8 }}>{para}</p>
          ))}
        </div>
      ))}

      <div style={{ background:'#1a1410', borderRadius:10, padding:'28px 32px', marginTop:32, textAlign:'center' }}>
        <div style={{ fontFamily:'Playfair Display,serif', fontSize:20, color:'#e8c97a', marginBottom:8 }}>Questions about our Terms?</div>
        <p style={{ color:'#a89a8a', fontSize:14, marginBottom:16 }}>Contact us at support@southjerseyvendormarket.com</p>
        <div style={{ display:'flex', gap:12, justifyContent:'center', flexWrap:'wrap' }}>
          <button className="btn-primary" onClick={()=>setTab('vendor')}>Add a Vendor Profile</button>
          <button className="btn-outline" onClick={()=>setTab('host')}>Add an Event</button>
        </div>
      </div>
    </div>
  );
}

export default TosPage;
